import Header from './header'
import Footer from './footer'
import Home from '../HOmes/home'
import NotFound from '../NotFound';
import Media from '../Branches/Media/media'
import UserList from '../Usersmanagement/userlist';
import Accounts from '../Usersmanagement/accounts';
import Userprofile from '../Usersmanagement/Element/userprofile';
import AccessHistory from '../Usersmanagement/accesshistory';
import RoleAndpermission from '../Usersmanagement/rolesandpermissions';
import { Routes, Route } from "react-router-dom";


function Landingpage({userId1, logout}) {
    // const [logout, setUsername] = useState(false);
    return (
        <div>
            {/* start header */}
            <Header
            userId={userId1}
            logout={logout} />

            <Routes>

                <Route path="/" element={<Home />} />

                <Route path="/Users" element={<UserList/>} />
                <Route path="/RoleandPermission" element={<RoleAndpermission/>} />
                <Route path="/Access_History" element={<AccessHistory/>} />
                <Route path="/Accounts" element={<Accounts/>} />
                <Route path="/User_Profile/:id" element={<Userprofile/>} />

                <Route path="/Media_Branch" element={<Media/>} />
               
                
                {/* Catch-all for unknown routes */}
                <Route path="*" element={<NotFound />} />

            </Routes>

            {/* footer */}
            <Footer />
        </div>
    )
}

export default Landingpage